/**
 * Canonical helpers for the internal finding-source note that consolidation prefixes onto
 * comments in private internal repositories. The note names the review agent, experiment arm,
 * detect model and DeepFilter verdict behind each posted finding. Its hidden markers let prompt
 * extraction strip it, as it strips the dev-mode filter note, while GitHub and the PR page still
 * show it.
 */
export const INTERNAL_FINDING_SOURCE_NOTE_START = '<!-- internal: finding-source -->';
export const INTERNAL_FINDING_SOURCE_NOTE_END = '<!-- /internal: finding-source -->';
export const INTERNAL_FINDING_SOURCE_NOTE_HEADER = '🧪 Internal: who found this comment';

const INTERNAL_FINDING_SOURCE_NOTE_BLOCK_REGEX =
  /<!-- internal: finding-source -->[\s\S]*?<!-- \/internal: finding-source -->\n*/g;

/** GitHub bullets are line-based, so each source collapses onto one line. */
function normalizeSourceLine(value: string): string {
  return value.replace(/\s+/g, ' ').trim();
}

/** Formats one bullet per finding source inside the hidden markers. */
export function formatInternalFindingSourceNote(sourceLines: readonly string[]): string {
  return [
    INTERNAL_FINDING_SOURCE_NOTE_START,
    INTERNAL_FINDING_SOURCE_NOTE_HEADER,
    ...sourceLines.map((line) => `- ${normalizeSourceLine(line)}`),
    INTERNAL_FINDING_SOURCE_NOTE_END,
  ].join('\n');
}

export function removeInternalFindingSourceNote(content: string): string {
  return content.replace(INTERNAL_FINDING_SOURCE_NOTE_BLOCK_REGEX, '');
}
